// The run on this iPad: the Assessment Sheet's new row and the rows waiting their turn behind it (asset-id-page.ts).
// Field Labels reads the same keys so its push count leaves out rows already waiting (PUSH_BY_ROOM_B7_WORDS.md item 7).

import { assetIdOf, BLANK_FORM, type ClassOption, type IdForm } from "./asset-id";

export const RUN_KEY = (company: string, site: string): string => `st_asset_id_run_${company}_${site}`;
export const DRAFT_KEY = (company: string, site: string): string => `st_asset_id_form_${company}_${site}`;

/** A new row someone has started: any of its first cells filled. A blank form is no row at all. */
export const draftStarted = (f: Pick<IdForm, "type" | "locNum" | "pos" | "loc">): boolean => Boolean(f.type || f.locNum || f.pos || f.loc);

/**
 * The Asset IDs waiting in the run on this iPad: the started new row and the rows behind it. Read from the stored
 * copy, the way the sheet brings it back when it opens. Nothing stored, or a bad copy: none.
 */
export function waitingIds(get: (k: string) => string | null, company: string, site: string, classes: readonly ClassOption[]): Set<string> {
  const out = new Set<string>();
  try {
    const rawDraft = get(DRAFT_KEY(company, site));
    const draft: IdForm = rawDraft ? { ...BLANK_FORM, ...(JSON.parse(rawDraft) as Partial<IdForm>) } : { ...BLANK_FORM };
    if (!draftStarted(draft)) return out;
    const rawRun = get(RUN_KEY(company, site));
    const run = rawRun ? (JSON.parse(rawRun) as unknown) : [];
    const list: IdForm[] = [draft, ...(Array.isArray(run) ? run.filter((f) => f && typeof f === "object").map((f) => ({ ...BLANK_FORM, ...(f as Partial<IdForm>) })) : [])];
    for (const f of list) {
      const id = assetIdOf(site, f, classes);
      if (id) out.add(id);
    }
  } catch {
    // A bad copy reads as no run.
  }
  return out;
}
